import { FunctionComponent } from 'react'

import { colors } from '../../../shared/styles/colors'
import Button from '../Button'
import LoadingBackdrop from '../LoadingBackdrop'
import { IScaffoldProps } from './ScaffoldComponent.types'
import { Container, Content, Footer, Title } from './styles'

const Scaffold: FunctionComponent<IScaffoldProps> = ({
  children,
  onClickBackButton,
  onClickNextButton,
  titleBackButton,
  titleNextButton,
  isNextButtonDisabled,
  color,
  title,
  icon: Icon,
  showFooterScaffold = true,
  loading,
  backgroundColor,
  boxShadow,
  padding,
}) => (
  <Container backgroundColor={backgroundColor} boxShadow={boxShadow}>
    {title && <Title>{title}</Title>}
    <Content backgroundColor={backgroundColor} padding={padding}>
      {children}
    </Content>

    {showFooterScaffold && (
      <Footer>
        {onClickBackButton && (
          <Button transparent onClick={onClickBackButton}>
            {titleBackButton}
          </Button>
        )}
        {onClickNextButton && (
          <Button
            color={color ?? `${colors.green}`}
            onClick={onClickNextButton}
            disabled={isNextButtonDisabled}
          >
            {Icon && <Icon />} {titleNextButton}
          </Button>
        )}
      </Footer>
    )}
    <LoadingBackdrop open={loading} color={colors.green} />
  </Container>
)

export default Scaffold
